angular.module('mtic.components.modules.bubbleModule')
.service('BubbleModuleItem', function(
  $log,
  $timeout,
  TIMING_CONSTANTS,
  language,
  EventManager,
  DEV_VARIABLES,
  ModuleFilter
) {

  // event manager
  var eventManager = new EventManager('BubbleModuleItem')

  // constructor
  return function BubbleModuleItem(
    item_info,
    ASSET_URL,
    eventBindings
  ){
    var bubbleModuleItem = this;
    // Public Variables
    bubbleModuleItem.id = item_info.id;
    bubbleModuleItem.name = item_info.name;
    bubbleModuleItem.slug = item_info.slug;
    bubbleModuleItem.type = item_info.resource_type;
    bubbleModuleItem.studentWork = item_info.studentWork;
    bubbleModuleItem.container = item_info.content.container;
    bubbleModuleItem.complete = item_info.complete;
    bubbleModuleItem.locked = item_info.locked;
    bubbleModuleItem.unlocked_by = item_info.unlocked_by;
    bubbleModuleItem.content = item_info.content;
    bubbleModuleItem.verletBody = null;
    bubbleModuleItem.parentItem = null;
    bubbleModuleItem.complete = item_info.complete;

    // Private Variables
    var agenda_highlight = null;
    var unclickableTypes = ['symlink'];
    var icon = new PIXI.Sprite();
    var sprite = bubbleModuleItem.sprite  = new PIXI.Sprite();
    var startClickPos = {
      x: 0,
      y: 0
    };
    var mouseOver, mouseOut, pointerdown, tooltip;

    // DEV complete
    if (DEV_VARIABLES.RESOURCES.MARK_COMPLETE.indexOf(bubbleModuleItem.slug ) > -1) {
      bubbleModuleItem.complete = true;
    }

    //Handle group stuff
    if (item_info.children && item_info.children.length > 0) {
      bubbleModuleItem.locked = true;
      var i = 0;
      for (i = 0; i < item_info.children.length; i++) {
        bubbleModuleItem.locked = bubbleModuleItem.locked && item_info.children[i].locked;
      }
      item_info.locked = bubbleModuleItem.locked;


      bubbleModuleItem.complete = true;
      for (i = 0; i < item_info.children.length; i++) {
        bubbleModuleItem.complete = bubbleModuleItem.complete && item_info.children[i].complete;
      }
      item_info.complete = bubbleModuleItem.complete;
      item_info.resourceState = {};
      item_info.resourceState.score_max = bubbleModuleItem.complete ? 1 : 0;
    }
    // Unlock DEV
    if(DEV_VARIABLES.RESOURCES.UNLOCK_THESE.indexOf(this.slug ) > -1) {
      this.locked = false;
    }

    // Private Methods

    var getIconFilename = function(item_info) {
      //assessments are easy
      if (item_info.resource_type === 'assessment') {
        if (item_info.complete)
        {
          return 'assessment_complete.png';
        }
        return 'assessment.png';
      }

      //get the color from item_info.display.color, fall back to "red" if it isn't defined
      var color_string = (item_info.display.color !== undefined) ? item_info.display.color : 'red';

      var suffix;
      if (item_info.locked) {
        suffix = "_locked";
      } else {
        if (!item_info.resourceState) {
          suffix = "_0"
        } else {
          var count = Math.floor(item_info.resourceState.score_max * 3);
          if (color_string === 'blue') {
            count = Math.min(count, 1);
          }
          suffix = "_" + count;
        }
      }
      var filename = "item_" + color_string + suffix + ".png";
      return filename;
    };

    var getItemDisplayName = function() {
      var itemDisplayName;
      if (item_info.display && item_info.display.nameLangId) {
        itemDisplayName = language.get(item_info.display.nameLangId)
      } else {
        itemDisplayName = language.get(item_info.slug, null, true)
      }
      if (!itemDisplayName) {
        itemDisplayName = item_info.name;
      }
      return itemDisplayName;
    }

    // Public Methods
    bubbleModuleItem.setDelegate = function(del) {
      var boundClick = (function(e) {
        del(bubbleModuleItem.slug);
      }).bind(bubbleModuleItem);
      sprite.on('pointertap', boundClick)
    }

    bubbleModuleItem.updateIcon = function() {
      if (bubbleModuleItem.type === 'symlink') {
        icon.texture = PIXI.loader.resources[ASSET_URL + "symlink.png"].texture;
      } else {
        icon.texture = PIXI.loader.resources[ASSET_URL + getIconFilename(item_info)].texture;
      }
    }
    bubbleModuleItem.buildTooltip = function() {
      if (tooltip !== null && tooltip !== undefined) {
        sprite.removeChild(tooltip);
        tooltip.interactive = false;
      }
      tooltip = new PIXI.Sprite();
      // Text Information
      var textInfo = new PIXI.Text(getItemDisplayName(), {
        fontFamily: 'Arial',
        align: 'center',
        fontSize: 24,
        fill: 0xFFFFFF,
        dropShadow: true,
        dropShadowDistance: 1,
        dropShadowBlur: 0,
        wordWrap: true,
        wordWrapWidth: 200
      });

      var tooltip_graphics = new PIXI.Graphics();

      var drawTooltipContainer = function() {
        tooltip_graphics.clear();
        // Draw Text Bubble that wraps around the text
        tooltip_graphics.lineStyle(0);
        tooltip_graphics.beginFill(0x3B5763);
        tooltip_graphics.drawRoundedRect(textInfo.x - 20, textInfo.y - 10, textInfo.width + 40, textInfo.height + 20, 10);
        tooltip_graphics.endFill();

        // Draw Triangle pointing to planet
        tooltip_graphics.beginFill(0x3B5763);
        tooltip_graphics.moveTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
        tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2), textInfo.y - 18);
        tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) + 5, textInfo.y - 10);
        tooltip_graphics.lineTo(textInfo.x + (textInfo.width / 2) - 5, textInfo.y - 10);
        tooltip_graphics.endFill();
        tooltip_graphics.x = -tooltip_graphics.width / 2 + 20;
        tooltip_graphics.y = icon.height / 2 + 10;
      }

      drawTooltipContainer();

      tooltip.addChild(tooltip_graphics);
      tooltip_graphics.addChild(textInfo);
      sprite.addChild(tooltip);
      tooltip.interactiveChildren = false;
      tooltip.visible = false;

      eventManager.listen('language:change', function() {
        if (textInfo === undefined) {
          return;
        }
        textInfo.setText(getItemDisplayName());
        drawTooltipContainer();
      })
    }
    bubbleModuleItem.onButtonClick = function() {
      if (unclickableTypes.indexOf(bubbleModuleItem.type) > -1) {
        return;
      }
      //Cancel click events if they dragged more than 100 pixels
      var curPos = sprite.toGlobal(new PIXI.Point(0, 0));
      if (Math.pow(startClickPos.x - curPos.x, 2) + Math.pow(startClickPos.y - curPos.y, 2) > 100 * 100) {
        return;
      }

      $log.debug('[[BubbleModuleItem]] clicking on', item_info, 'LOCK STATUS:::::::::::::', bubbleModuleItem.locked);
      if (DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(item_info.slug) > -1) {
        bubbleModuleItem.locked = true;
      }
      if(!ModuleFilter.checkAvailable(item_info)){
        bubbleModuleItem.locked = true;
        item_info.locked = true;
        eventManager.broadcast('display-maintenance-message', item_info.slug);
        return;
      }
      $timeout(function() {
        sprite.scale.set(1, 1);
        if(eventBindings.onItemClick) {
          eventBindings.onItemClick(item_info, bubbleModuleItem);
        }
        // eventManager.broadcast('module:select:resource', item_info);
        // eventManager.broadcast('module:stop:pan')
      }, TIMING_CONSTANTS.INSTANT)
    };
    bubbleModuleItem.unlock = function() {
      item_info.locked = false;
      bubbleModuleItem.locked = false;
      bubbleModuleItem.updateIcon();
    };
    bubbleModuleItem.lock = function() {
      item_info.locked = true;
      bubbleModuleItem.locked = true;
      bubbleModuleItem.updateIcon();
    }
    bubbleModuleItem.getItemInfo = function() {
      return item_info;
    }
    bubbleModuleItem.setItemComplete = function() {
      bubbleModuleItem.updateIcon();
      if (bubbleModuleItem.studentWork) {
        bubbleModuleItem.studentWork.completions++;
      } else {
        bubbleModuleItem.studentWork = {
          completions: 1,
        };
      }
    }
    //For setting up verlet links to items inside a folder
    //items in minimized folders should verlet links to their parent
    bubbleModuleItem.getLinkedBody = function() {
      if (bubbleModuleItem.shouldBeOnMap()) {
        return bubbleModuleItem.verletBody;
      } else {
        return bubbleModuleItem.parentItem.getLinkedBody();
      }
    }
    //Map items inside mimized folder items get ignored
    bubbleModuleItem.shouldBeOnMap = function() {
      if (bubbleModuleItem.parentItem !== null) {
        return bubbleModuleItem.parentItem.isExpanded;
      } else {
        return bubbleModuleItem.isExpanded === true ? false : true;
      }
    }
    bubbleModuleItem.showHighlight = function() {
      if (bubbleModuleItem.type === 'symlink') {
        return;
      }
      if (tooltip) {
        tooltip.visible = true;
      }
      sprite.scale.set(1.1, 1.1);
      if (sprite.parent !== null) {
        sprite.parent.setChildIndex(sprite, sprite.parent.children.length - 1);
      }
    }
    bubbleModuleItem.undoAgendaHighlight = function() {}
    bubbleModuleItem.showAgendaHighlight = function() {
      // $log.log('show agenda prehighlight : ', agenda_highlight)
      if (agenda_highlight === null)
      {
        agenda_highlight = new PIXI.Graphics();
        agenda_highlight.lineStyle(8, 0xAAAABB);
        agenda_highlight.drawCircle(0,0, 45);
        icon.addChild(agenda_highlight);
      }else{
        bubbleModuleItem.hideAgendaHighlight();
      }
    }
    bubbleModuleItem.hideAgendaHighlight = function() {
      if (agenda_highlight !== null)
      {
        icon.removeChild(agenda_highlight);
        agenda_highlight = null;
      }
    }
    bubbleModuleItem.hideHighlight = function() {
      if (tooltip) {
        tooltip.visible = false;
      }
      sprite.scale.set(1, 1);
    }
    bubbleModuleItem.pointerdown = function() {
      sprite.scale.set(0.9, 0.9);
      startClickPos = sprite.toGlobal(new PIXI.Point(0, 0));
      if (window.DEBUG_TOUCH){ $log.log('bubbleModuleItem pointdown ; ', JSON.stringify(startClickPos)); }
    }

    // INIT
    icon.anchor.set(0.5, 0.5);
    mouseOver = bubbleModuleItem.showHighlight.bind(bubbleModuleItem);
    mouseOut = bubbleModuleItem.hideHighlight.bind(bubbleModuleItem);
    pointerdown = bubbleModuleItem.pointerdown.bind(bubbleModuleItem);

    sprite.on('mouseover', function() {
      mouseOver();
    });
    sprite.on('pointerout', function() {
      mouseOut();
    });
    sprite.on('pointerdown', function() {
      pointerdown();
    });

    if (item_info.resource_type !== "group") {
      var boundClick = bubbleModuleItem.onButtonClick.bind(bubbleModuleItem);
      sprite.on('pointertap', boundClick);
    } else if (item_info.resource_type !== 'symlink') {
      bubbleModuleItem.open = false;
    }

    bubbleModuleItem.updateIcon();
    if (bubbleModuleItem.type === "group") {
      var bg = new PIXI.Sprite(icon.texture);
      bg.width += 20;
      bg.height += 20;

      bg.anchor.set(0.5, 0.5);
      sprite.addChild(bg);
    }
    sprite.addChild(icon);


    if (item_info.display.position !== undefined) {
      sprite.position.set(item_info.display.position.x, item_info.display.position.y);
    } else {
      sprite.position.set(0, 0);
    }
    sprite.interactive = true;
    sprite.buttonMode = true;
    bubbleModuleItem.buildTooltip();
  }
})
